import React from 'react';
import SvgIcon from './SvgIcon';

function EncryptedIcon({ width }) {
    return (
        <SvgIcon className="EncryptedIcon" width={width}>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="100%"
                height="100%"
                fill="none"
                viewBox="0 0 32 32"
            >
                <path
                    fill="#000"
                    d="M14.32 19.667h3.36l-.754-4.21c.418-.18.755-.462 1.011-.845.256-.384.383-.81.383-1.279 0-.639-.227-1.185-.68-1.64-.454-.453-1-.68-1.64-.68-.64 0-1.186.227-1.64.68-.453.455-.68 1.001-.68 1.64 0 .469.127.895.383 1.279.256.383.593.665 1.011.844l-.753 4.21zM16 28.64c-2.884-.786-5.271-2.484-7.163-5.092C6.946 20.94 6 18.024 6 14.8V7.128l10-3.743 10 3.743V14.8c0 3.224-.946 6.14-2.837 8.749-1.892 2.608-4.28 4.306-7.163 5.092zm0-2.108c2.311-.733 4.222-2.2 5.733-4.4C23.244 19.933 24 17.49 24 14.8V8.5l-8-2.987L8 8.5v6.3c0 2.689.756 5.133 2.267 7.333 1.51 2.2 3.422 3.667 5.733 4.4z"
                />
            </svg>
        </SvgIcon>
    );
}

export default EncryptedIcon;
